import { Divider, Text } from '@mantine/core';
import React from 'react';

interface DaySeparatorProps {
  label: string;
}

export const DaySeparator = React.memo(function DaySeparator({
  label,
}: DaySeparatorProps) {
  return (
    <Divider
      label={
        <Text size="xs" color="dimmed" weight={500}>
          {label}
        </Text>
      }
      labelPosition="center"
      my="xs"
    />
  );
});
